module.exports = __webpack_public_path__ + "img/icon_cggl.53e55786.png";